import type { MusicService } from '../types';
import { ImporterID, MusicAPIIntegrationID } from '../ids';

/**
 * Demoify — the destination of the public transfer demo.
 *
 * It is a real destination as far as the transfer engine is concerned and a
 * fiction as far as music is concerned: it accepts a library, keeps it for a
 * few days and plays nothing. `isSupported: false` keeps it out of every
 * picker in the apps; the demo wizard names it directly.
 */
export const demoify: MusicService = {
  id: 'demoify',
  name: 'Demoify',
  shortName: 'Demoify',
  isSupported: false,
  isComingSoon: false,
  areStatsSupported: false,
  areStatsComingSoon: false,
  isAlbumTransferSupported: true,
  color: {
    primary: '#6B4EFF',
    label: '#6B4EFF',
    background: '#4B2CE0',
  },
  /**
   * What the demo destination can do.
   *
   * These are not claims about a remote API — there is no remote API. They are
   * what the wizard reads to decide which parts of a library the demo may
   * offer to move, and the demo offers all of them: a demo that quietly
   * refused albums and artists would be demonstrating less than the product.
   */
  authenticatedApiCapabilities: {
    doesSupportUpdatingPlaylists: true,
    doesSupportRemovingPlaylists: true,
    doesSupportRemovingTracks: true,
    doesSupportMovingTracks: true,
    doesSupportAddingTracksToLibrary: true,
    doesSupportRemovingTracksFromLibrary: true,
    doesSupportFetchingLibraryAlbums: true,
    doesSupportFetchingAlbums: true,
    doesSupportFetchingAlbumTracks: true,
    doesSupportAddingAlbums: true,
    doesSupportRemovingAlbums: true,
    doesSupportFetchingLibraryArtists: true,
    doesSupportFetchingArtists: true,
    doesSupportAddingArtistsToLibrary: true,
    doesSupportRemovingArtistsFromLibrary: true,
    doesSupportSearchByISRC: true,
    doesReturnISRC: true,
    doesReturnPreviewURL: false,
    doesReturnUserEmail: false,
    doesReturnUserCountry: false,
    maxLimit: 50,
  },
  importerID: ImporterID.Demo,
  musicAPIID: MusicAPIIntegrationID.Demo,
};
